export function openSelectingDevicesDialog(filter_function = undefined, on_ok_function = undefined, selected_device_ids = undefined) {
    return {
        type: 'SELECTING_DEVICES_DIALOG__OPEN',
        filter_function,
        on_ok_function,
        selected_device_ids,
    };
}
export const closeSelectingDevicesDialog = (selected_device_ids) => ({
    type: 'SELECTING_DEVICES_DIALOG__CLOSE',
    selected_device_ids,
});
